const upgrade = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async getFindLatestApply({ rootState }, params = {}) {
      const data = await rootState.http("/store/upgradeRenewal/findLatestApply", params, {
        errorMessage: false
      });
      return data;
    },
    async queryPurchaseHistory({ rootState }, params = {}) {
      const data = await rootState.http("/store/upgradeRenewal/queryPurchaseHistory", params, {
        errorMessage: false
      });
      return data;
    },
    async informationConfirmedStep({ rootState }, params = {}) {
      const data = await rootState.http("/store/upgradeRenewal/informationConfirmedStep", params);
      return data;
    },
    async chooseVersion({ rootState }, params = {}) {
      const data = await rootState.http("/store/upgradeRenewal/chooseVersion", params);
      return data;
    },
    async onlinePayment({ rootState }, params = {}) {
      const data = await rootState.http("/store/upgradeRenewal/onlinePayment", params, {
        errorMessage: false
      });
      return data;
    },
    async findOrder({ rootState }, params = {}) {
      const data = await rootState.http("/store/upgradeRenewal/findOrder", params, {
        errorMessage: false
      });
      return data;
    },
    async offlinePayment({ rootState }, params = {}) {
      const data = await rootState.http("/store/upgradeRenewal/offlinePayment", params, {
        errorMessage: false
      });
      return data;
    },
    async queryFunctionList({ rootState }, params = {}) {
      const data = await rootState.http("/store/upgradeRenewal/queryFunctionList", params, {
        errorMessage: false
      });
      return data;
    },
    async queryAgentList({ rootState }, params = {}) {
      const data = await rootState.http("/storeAgent/queryAvailableAgent", params, {
        errorMessage: false
      });
      return data;
    }
  }
};
export default upgrade;
